module.exports = __webpack_public_path__ + "img/zhanjia3.e29fe79c.jpeg";